export const TYPE_COMPTE = [
    { id: 'AC', description: 'Actif' },
    { id: 'EX', description: 'Inactif' },
    { id: 'PA', description: 'Passif' },
    { id: 'AV', description: 'Avoir' },
    { id: 'RE', description: 'Revenu' },
    { id: 'DE', description: 'Dépense' }
]
export const MOIS = ["Septembre", "Octobre", "Novembre", "Décembre", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet"]